"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.HeaderSkeleton = exports.CategorySkeleton = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(3),
        justifyContent: 'center',
        margin: theme.spacing(0, 'auto', 16),
        maxWidth: 1014,
        padding: theme.spacing(0, 3),
        [theme.breakpoints.up('sm')]: {
            maxWidth: 1064,
            padding: theme.spacing(0, 8)
        }
    };
});
const HeaderSkeleton = exports.HeaderSkeleton = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        height: 178,
        marginBottom: theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            height: 187
        }
    };
});
const CategorySkeleton = exports.CategorySkeleton = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        borderRadius: theme.shape.borderRadius,
        height: 110,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 234
        }
    };
});
